import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import RFCheckboxField from '../../../components/ReduxFormComps/RFCheckboxField';
import FormQuestionText from './FormQuestionText';
import { YES_ANSWER, NO_ANSWER } from './variables';

const checkboxOnChange=(e,props,questionId,anwerType)=>{
    const { changeFieldValue } = props;
  
    if (e.target.checked){
        if (anwerType==YES_ANSWER){
            changeFieldValue(`${NO_ANSWER}${questionId}`,false);
        }else {
            changeFieldValue(`${YES_ANSWER}${questionId}`,false);
        }
    }
}

let FormQuestion=props=> {
    const { formQuestion } = props;
    const { question_text,question_id,has_answer_response } = formQuestion;
    
    return (
        <div className='container'>
            <div className='row'>
                <div className={has_answer_response?'col-sm-8':'col-sm'}>
                    <FormQuestionText {...props} questionText={question_text} questionId={question_id} />
                </div>
                {has_answer_response?(
                <div className='col-sm-1'>
                    <Field name={`${YES_ANSWER}${question_id}`} 
                        component={RFCheckboxField} 
                        label="YES" 
                        onChange={(e)=> checkboxOnChange(e,props,question_id,YES_ANSWER)}
                        />
                </div>
                ):null}
                {has_answer_response?(
                <div className='col-sm-1'>
                    &nbsp;
                </div> 
                ):null}

                {has_answer_response?(
                <div className='col-sm-1'>
                    <Field name={`${NO_ANSWER}${question_id}`} 
                    component={RFCheckboxField} 
                    label="NO" 
                    onChange={(e)=> checkboxOnChange(e,props,question_id,NO_ANSWER)}
                    />
                </div>
                ):null}   
            
            </div>        
        </div>    
    )
} 

FormQuestion.propTypes = {
    formQuestion: PropTypes.object.isRequired
}
export default FormQuestion;


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/FormQuestion.js